export const pwmRank = {
  SECURITY_OFFICER: "Security Officer",
  SENIOR_SECURITY_OFFICER: "Senior Security Officer",
  SECURITY_SUPERVISOR: "Security Supervisor",
  SENIOR_SECURITY_SUPERVISOR: "Senior Security Supervisor",
  CHIEF_SECURITY_OFFICER: "Chief Security Officer",
};
